'use client';

import clsx from 'clsx';
import { ReactNode, useState } from 'react';

export function Dropdown({
  openElement,
  children,
  className,
  dropdownClass,
  positionClass,
  removeDelay,
}: {
  openElement: ReactNode;
  children: ReactNode;
  className?: string;
  dropdownClass?: string;
  positionClass: string;
  removeDelay?: boolean;
}) {
  const delay = removeDelay ? 0 : 333; // ms
  const [showPopup, setShowPopup] = useState(false);
  let timeout: NodeJS.Timeout | undefined = undefined;

  return (
    <div
      className={clsx('relative grid place-items-center', className)}
      onMouseEnter={() => {
        if (timeout) clearTimeout(timeout);
        setShowPopup(true);
      }}
      onMouseLeave={() => (timeout = setTimeout(() => setShowPopup(false), delay))}
    >
      <label className="grid place-items-center" tabIndex={1}>
        {openElement}
      </label>
      <ul
        className={clsx(
          'bg-base-200 rounded-box [&>li>a]:rounded-box [&>li>button]:rounded-box z-1 absolute flex w-52 flex-col p-2 shadow-xl [&>li>*]:px-3 [&>li>*]:py-1 [&>li>a:hover]:bg-neutral-50/10 [&>li>a]:block [&>li>button:hover]:bg-neutral-50/10 [&>li>button]:block [&>li]:w-full',
          showPopup ? positionClass : 'hidden',
          dropdownClass,
        )}
      >
        {children}
      </ul>
    </div>
  );
}
